module.exports = {"652323100":"呼图壁镇","652323101":"大丰镇","652323102":"雀尔沟镇","652323103":"二十里店镇","652323104":"园户村镇","652323105":"五工台镇","652323201":"石梯子哈萨克民族乡","652323402":"干河子林场","652323405":"呼图壁种牛场","652323520":"兵团一零五团","652323521":"兵团一零六团","652323523":"兵团芳草湖总场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652323.json
// module id = 3073
// module chunks = 0